import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3682172e"
import script from "./List.js?vue&type=script&lang=js&external"
export * from "./List.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports